import React from 'react';
import {
    Typography,
    Tooltip,
    ListItem,
    ListItemText
} from '@material-ui/core/';
import TagManager from 'react-gtm-module';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
//css
import ComunicadosCss from './comunicados-css';
const useStyles = ComunicadosCss();

export default function ComunicadosHome(props){
    const classes = useStyles();
    const capitalized = (value) => {
        return value[0].toUpperCase() + value.substr(1);
    }

    const checkRoute = (value) => {
        if (value['dir'].includes(';@Assets')) {
            props.props.pai.props.router.push(`${value['route']}s/arquivos/${value['id']}`);
        } else {
            window.open(value['dir'], '_blank');
        }
        
        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:inicio',
              eventAction: 'clique:comunicados',
              eventLabel: `arquivo-${value['id']}`,
            }
        });
    };

    return (
       <>
        {props.state.itens.length === 0 &&
            <Typography variant="body1" component="p" align={'center'}>
                Nenhum {props.props.message}!
            </Typography>
        }
        {props.state.itens.map((item, index) => (
            <ListItem alignItems={'flex-start'}  
                disablegutters={"true"}
                key={index} 
                button                    
            >
                    {item.DS_LINK ?
                        <ListItemText 
                            primary={
                                <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inline + ' ' +classes.data}
                                        color="textPrimary"
                                        style={(props.state.listaNovo.includes(item.ID_CFG))?{fontWeight:'bold'}:null}
                                    >
                                        {(item.DT_LANCAMENTO.length>0)?item.DT_LANCAMENTO.substr(0, item.DT_LANCAMENTO.indexOf(' ')):''} 
                                    </Typography>
                                </React.Fragment>
                            }
                            secondary={
                                <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        className={classes.inline}
                                        color="textPrimary"
                                        style={(props.state.listaNovo.includes(item.ID_CFG))?{fontWeight:'bold'}:null}
                                    >
                                        {item.DS_TITULO?capitalized(item.DS_TITULO):capitalized(item.TX_DESCRICAO)} 
                                    </Typography>
                                </React.Fragment>
                            }
                            onClick={()=>{
                                checkRoute({id: item.ID_CFG, dir: item.DS_LINK, route: 'comunicado'})
                            }}
                        />
                    :
                        <a href={"/#"}>
                            <ListItemText primary={item.DS_TITULO?item.DS_TITULO:item.TX_DESCRICAO} />
                        </a>
                    }
                
                
                {props.state.permissao === 1 &&
                    <Tooltip title={'Lançamento marcado para dia '+item.DT_LANCAMENTO.substr(0, item.DT_LANCAMENTO.indexOf(' '))}>
                        <CalendarTodayIcon className={classes.icons} />
                    </Tooltip>
                }

            </ListItem>
        ))}
        </>
    
    );

}